import axios from "axios";

const API = axios.create({
    baseURL: 'https://beta.aisafetygenie.com/admin/api',
});

export default API;